var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPencil = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4345 2.56551C13.2528 2.38461 13.0371 2.2415 12.7998 2.14444C12.5625 2.04739 12.3083 1.99831 12.052 2.00004C11.7956 2.00178 11.5421 2.05429 11.3061 2.15456C11.0702 2.25482 10.8564 2.40083 10.6772 2.58418L2.94399 10.3174L2 14L5.68261 13.0555L13.4158 5.32227C13.5992 5.14314 13.7453 4.92944 13.8456 4.69352C13.9459 4.4576 13.9984 4.20413 14.0001 3.94778C14.0019 3.69143 13.9528 3.43728 13.8557 3.20002C13.7586 2.96276 13.6154 2.7471 13.4345 2.56551V2.56551Z",
    stroke: "#555555",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45703 3.80469L12.1951 6.54278",
    stroke: "#555555",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPencil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pencil.34a3ea928206b9313d04987039e613c7.svg";